import type { BoxT } from '@mentimeter/ragnar-ui/box';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { MARGIN_HORIZONTAL } from './constants';

interface ScalesDimensionLabelsProps extends BoxT {
  rangeMinLabel: string;
  rangeMaxLabel: string;
}

export const ScalesDimensionLabels = ({
  rangeMinLabel,
  rangeMaxLabel,
  ...rest
}: ScalesDimensionLabelsProps) => {
  return (
    <Box
      aria-hidden
      width="100%"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      px={MARGIN_HORIZONTAL}
      {...rest}
    >
      <Text color="textWeak" fontSize="175" fontWeight="semiBold">
        {rangeMinLabel}
      </Text>
      <Text color="textWeak" fontSize="175" fontWeight="semiBold">
        {rangeMaxLabel}
      </Text>
    </Box>
  );
};
